/**
 * CopyWeekDialog Component
 * Dialog for copying shifts to future weeks
 */

import React from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

/**
 * CopyWeekDialog - Modal for copying week's shifts
 * 
 * @param {Object} props
 * @param {boolean} props.open - Dialog open state
 * @param {Function} props.onClose - Close handler
 * @param {Object} props.selectedWeek - Selected week (dayjs object)
 * @param {Array} props.shifts - All shifts data
 * @param {Array} props.selectedForCopy - Selected employee IDs for copy
 * @param {Object} props.copyWeekForm - Form state {weeksAhead, skipExisting}
 * @param {Function} props.setCopyWeekForm - Form state setter
 * @param {boolean} props.copyingWeek - Loading state
 * @param {Function} props.onCopy - Copy handler
 */
export default function CopyWeekDialog({
  open,
  onClose,
  selectedWeek,
  shifts,
  selectedForCopy,
  copyWeekForm,
  setCopyWeekForm,
  copyingWeek,
  onCopy,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Αντιγραφή Εβδομάδας
        <Typography variant="body2" color="textSecondary">
          Από: {selectedWeek.format('DD/MM')} - {selectedWeek.add(6, 'day').format('DD/MM')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              {selectedForCopy.length === 0 
                ? `${shifts.length} βάρδιες θα αντιγραφούν`
                : `${shifts.filter(s => selectedForCopy.includes(s.employee_id)).length} βάρδιες από ${selectedForCopy.length} υπαλλήλους`
              }
            </Typography>
          </Alert>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel>Εβδομάδες μπροστά</InputLabel>
            <Select
              value={copyWeekForm.weeksAhead}
              label="Εβδομάδες μπροστά"
              onChange={(e) => setCopyWeekForm({ ...copyWeekForm, weeksAhead: e.target.value })}
            >
              <MenuItem value={1}>1 εβδομάδα</MenuItem>
              <MenuItem value={2}>2 εβδομάδες</MenuItem>
              <MenuItem value={3}>3 εβδομάδες</MenuItem>
              <MenuItem value={4}>4 εβδομάδες</MenuItem>
            </Select>
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                checked={copyWeekForm.skipExisting}
                onChange={(e) => setCopyWeekForm({ ...copyWeekForm, skipExisting: e.target.checked })}
              />
            }
            label="Παράλειψη αν υπάρχει ήδη βάρδια"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={copyingWeek}>Ακύρωση</Button>
        <Button 
          onClick={onCopy} 
          variant="contained" 
          disabled={copyingWeek}
          startIcon={<ContentCopyIcon />}
        >
          {copyingWeek ? 'Αντιγραφή...' : 'Αντιγραφή'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

